import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styles from "./UploadAnswerSheet.module.css";
import Select from "react-select";
import { AxiosInstance } from "../../../../../../axios";
import { customStyles } from "../../../../../../pages/customStyles";
import DatePickerSample from "../../../../DatePicker";
import moment from "moment";
import { ImageUrlPrefix } from "../../../../../../labels";
import { Download } from "@mui/icons-material";
import { UserContext } from "../../../../../../context/UserDetails";
import toast from "react-hot-toast";

function UploadAnswerSheet() {
  const {  logout } = useContext(UserContext);
  const { id } = useParams();
  // ------------ Select option -------
  const userJSON = sessionStorage.getItem("userDetails");
  let userid_admin = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid_admin = user.user_id;
    } else {
      logout();
    }
  } else {
    console.log("User Id cannot available in session storage");
  }

  const [batchList, setbatchList] = useState([]);
  const [subject_test, setSubject_test] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const datePickerRef = useRef(null);
  const batch_range_fromRef = useRef(null);
  const batch_range_toRef = useRef(null);
  const student_name_ref = useRef(null);
  const overall_rank_ref = useRef(null);
  const batch_name_ref = useRef(null);
  const exam_name_ref = useRef(null);
  const medium_of_instruction_ref = useRef(null);
  const answersheet_path_ref = useRef(null);
  const applicable_batch_ref = useRef(null);
  const STSubjectref = useRef([React.createRef()]);
  const STTopicref = useRef([React.createRef()]);
  const navigate = useNavigate();
  const [fldata, setFldata] = useState({
    student_name: "",
    overall_rank: "",
    batch_name: "",
    batch_id: "",
    course_name: "",
    sub_category: "",
    category: "",
    exam_name: "",
    date_of_exam: "",
    medium_of_instruction: "",
    medium_of_instruction_name: "",
    answersheet_path: null,
    answersheet_original_path: null,
    batch_range_from: "",
    batch_range_to: "",
  });
  const [error, setError] = useState({});
  const [appBatch, setAppBatch] = useState([]);
  const [mediumOption, setMediumOption] = useState([
    {
      value: 0,
      label: "Tamil",
    },
    {
      value: 1,
      label: "English",
    },
  ]);

  useEffect(() => {
    AxiosInstance.post(`api/batch/list`, {
      category: "",
      status: [1, 0], // ongoing batches only
      batch_type: "",
      medium: "",
      class_mode: "",
      start_date: "",
      end_date: "",
      start_time: "",
      c_start_date: "",
      c_end_date: "",
      end_time: "",
      search: "",
      type: "",
      location: "",
    })
      .then((res) => {
        if (res.data.status === true) {
          const batchListss = res.data.data.map((item, index) => ({
            value: item.id,
            label: item.name,
            course_name: item.category_class,
            sub_category: item.subcategory,
            category: item.category,
          }));
          setbatchList(batchListss);
        } else {
          setbatchList([]);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);

  useEffect(() => {
    const fetchAndSetData = async () => {
      if (id) {
        try {
          const res = await AxiosInstance.post(
            `api/test/descriptive/topper_view`,
            { id }
          );

          if (res.data.status) {
            const lsv = res.data.data;

            setFldata({
              student_name: lsv[0]?.student_name || "",
              overall_rank: lsv[0]?.over_all_rank || "",
              batch_name: lsv[0]?.batch_name || "",
              batch_id: lsv[0]?.batch_id || "",
              exam_name: lsv[0]?.exam_name || "",
              date_of_exam: lsv[0]?.exam_date
                ? moment(lsv[0].exam_date).format("YYYY/MM/DD")
                : "",
              medium_of_instruction:
                lsv[0]?.medium === 0 ? lsv[0]?.medium : lsv[0]?.medium || "",
              medium_of_instruction_name:
                lsv[0]?.medium === 1 ? "English" : "Tamil",
              answersheet_path: lsv[0]?.answer_sheet_path || null,
              answersheet_original_path:
                lsv[0]?.answer_sheet_original_path || null,
              batch_range_from: lsv[0]?.from_date
                ? moment(lsv[0].from_date).format("YYYY/MM/DD")
                : "",
              batch_range_to: lsv[0]?.to_date
                ? moment(lsv[0].to_date).format("YYYY/MM/DD")
                : "",
              category: lsv[0]?.category_name || "",
              sub_category: lsv[0]?.sub_category_name || "",
              course_name: lsv[0]?.course_name || "",
            });

            const transformedSubTopic = lsv[0]?.subject
              ? await Promise.all(
                  lsv[0].subject.map(async (sd, index) => ({
                    pks: sd.id,
                    id: index + 1,
                    STSubject: sd.subject,
                    STSubject_id: sd.subject_id,
                    STTopicOption: [],
                    STtopic: sd.test_topics.map((topic) => ({
                      value: topic.test_topic_id,
                      label: topic.test_topic_name,
                    })),
                    STSubject_error: "",
                    STtopic_error: "",
                  }))
                )
              : [];

            setSubTopic(transformedSubTopic);

            const subjectNames = lsv[0]?.subject
              ? lsv[0].subject.map((sd) => sd.subject)
              : [];
            const tesTopic = await Promise.all(
              subjectNames.map((subject) =>
                GetSTopic(
                  lsv[0].category_name,
                  lsv[0].sub_category_name,
                  lsv[0].course_name,
                  subject
                )
              )
            );
            setTestTopic(tesTopic.flat());

            const AppBt =
              lsv[0]?.applicable_batch?.length > 0
                ? lsv[0].applicable_batch.map((iop) => ({
                    value: iop.id,
                    label: iop.name,
                  }))
                : [];
            setSelectedOption(AppBt);
            const FROMDATE = lsv[0]?.from_date
              ? moment(lsv[0].from_date).format("DD/MM/YYYY")
              : "";
            const TODATE = lsv[0]?.to_date
              ? moment(lsv[0].to_date).format("DD/MM/YYYY")
              : "";
            const AppOption = await getApplicableBatch(FROMDATE, TODATE);
            setAppBatch(AppOption);
          }
        } catch (error) {
          console.error("Error fetching topper view data:", error);
        }
      }
    };

    fetchAndSetData();
  }, [id]);

  const handleSelectChange = (selected) => {
    setSelectedOption(selected);
    setError({
      ...error,
      ["appliBatch"]: "",
    });
  };

  // ---------Subject and Topics ---(start)
  const [subTopic, setSubTopic] = useState([
    {
      id: 1,
      STSubject: "",
      STSubject_id: "",
      STTopicOption: [],
      STtopic: [],
      STSubject_error: "",
      STtopic_error: "",
    },
  ]);

  const [test_topic, setTestTopic] = useState([]);

  // Fetch subjects and topics from API when the component mounts
  useEffect(() => {
    if (fldata.category && fldata.sub_category && fldata.course_name) {
      AxiosInstance.post("/api/all/getSubjects", {
        category: fldata.category,
        sub_category: fldata.sub_category,
        course_name: fldata.course_name,
      })
        .then((res) => {
          if (res.data.status === true) {
            if (res.data.data.length > 0) {
              const subject = res.data.data.map((item, index) => ({
                value: item.id,
                label: item.subject,
                type: item.type,
                category: item.category,
                subcategory: item.subcategory,
                course_name: item.course_name,
                subject: item.subject,
              }));
              setSubject_test(subject);
            } else {
              setSubject_test([]);
            }
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [fldata.batch_name]);

  // Handle change
  const handleChange = (event) => {
    const { name, value, files, checked } = event.target;
    if (name === "AnswerSheetFile" && files && files.length > 0) {
      const answerSheet_file = files[0];
      if (files[0].type == "application/pdf") {
        const formData = new FormData();
        formData.append("answer_sheet", answerSheet_file);
        AxiosInstance.post("api/upload/", formData)
          .then((res) => {
            setFldata({
              ...fldata,
              answersheet_path: res.data.path,
              answersheet_original_path: res.data.originalname,
            });
            setError({
              ...error,
              ["answersheet_path"]: "",
            });
          })
          .catch((error) => {
            return error;
          });
      } else {
        let err = "PDF files only allowed";
        setError({
          ...error,
          ["answersheet_path"]: err,
        });
      }
    } else {
      setFldata({
        ...fldata,
        [name]: value,
      });
      setError({
        ...error,
        [name]: "",
      });
    }
  };

  useEffect(() => {
    if (fldata.batch_range_from && fldata.batch_range_to) {
      AxiosInstance.post(`api/batch/list`, {
        category: "",
        status: [1, 0], // ongoing batches only
        batch_type: "",
        medium: "",
        class_mode: "",
        start_date: fldata.batch_range_from + " 00:00:00",
        end_date: fldata.batch_range_to + " 23:59:00",
        start_time: "",
        c_start_date: "",
        c_end_date: "",
        end_time: "",
        search: "",
        type: "",
        location: "",
      })
        .then((res) => {
          if (res.data.status === true) {
            if (res.data.data.length > 0) {
              const cfg = res.data.data.map((item, index) => ({
                value: item.id,
                label: `${item.name} - ${item.medium}`,
                course_name: item.category_class,
                sub_category: item.subcategory,
                category: item.category,
              }));
              setAppBatch(cfg);
            } else {
              setAppBatch([]);
            }
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [fldata.batch_range_from, fldata.batch_range_to]);

  // option select change

  const handlesELECToPTIONChange = (selectedOpt, names) => {
    if (names === "batch_name") {
      if (selectedOpt) {
        setFldata({
          ...fldata,
          ["batch_name"]: selectedOpt.label,
          ["batch_id"]: selectedOpt.value,
          ["course_name"]: selectedOpt.course_name,
          ["sub_category"]: selectedOpt.sub_category,
          ["category"]: selectedOpt.category,
        });
        setError({
          ...error,
          ["batch_name"]: "",
        });
      } else {
        setFldata({
          ...fldata,
          ["batch_name"]: "",
          ["batch_id"]: "",
          ["course_name"]: "",
          ["sub_category"]: "",
          ["category"]: "",
        });
        setSubTopic((prevState) => {
          return prevState.map((q) => {
            return {
              ...q,
              ["STSubject"]: "",
              ["STSubject_id"]: "",
              ["STSubject_error"]: "",
              ["STtopic"]: [],
              ["STTopicOption"]: [],
              ["STtopic_error"]: "",
            };
          });
        });
        setSubject_test([]);
        setTestTopic([]);
      }
    } else if (names === "medium_of_instruction") {
      if (selectedOpt) {
        setFldata({
          ...fldata,
          ["medium_of_instruction"]: selectedOpt.value,
          ["medium_of_instruction_name"]: selectedOpt.label,
        });
        setError({
          ...error,
          ["medium_of_instruction"]: "",
          ["medium_of_instruction_name"]: "",
        });
      } else {
        setFldata({
          ...fldata,
          ["medium_of_instruction"]: "",
          ["medium_of_instruction_name"]: "",
        });
      }
    }
  };

  // Handle the date change
  const handleDateChange = (date, NMAS) => {
    const dateDOB = moment(date).format("YYYY-MM-DD");
    setFldata({
      ...fldata,
      [NMAS]: dateDOB,
    });
    setError({
      ...error,
      [NMAS]: "",
    });
    setAppBatch([]);
  };

  // -----end-----------

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };
  // add sub and topic
  const AddSubTop = () => {
    STSubjectref.current.push(React.createRef());
    STTopicref.current.push(React.createRef());
    setSubTopic((prevState) => [
      ...prevState,
      {
        id: prevState.length > 0 ? prevState.length + 1 : 1,
        STSubject: "",
        STSubject_id: "",
        STTopicOption: [],
        STtopic: [],
        STSubject_error: "",
        STtopic_error: "",
      },
    ]);
  };
  //delete sub and topics
  const deleteSubTop = (id) => {
    const val = subTopic
      .filter((item) => item.id !== id)
      .map((item, index) => ({ ...item, id: index + 1 }));
    setSubTopic(val);
  };

  const handleSubjectOptionChange = (option, id, name) => {
    if (name === "STSubject") {
      if (option) {
        const OptionSelected = {
          value: option.value,
          label: option.label,
          type: option.type,
          category: option.category,
          subcategory: option.subcategory,
          course_name: option.course_name,
          subject: option.label,
        };
        setSubTopic((prevState) => {
          const isAlreadyExists = prevState.some(
            (q) => q.STSubject_id === OptionSelected.value
          );

          return prevState.map((q) => {
            if (q.id === id) {
              if (isAlreadyExists) {
                return {
                  ...q,
                  [name]: "",
                  STSubject_id: "",
                  STSubject_error: "This subject is already selected.",
                  STTopicOption: [],
                };
              } else {
                return {
                  ...q,
                  [name]: OptionSelected.label,
                  STSubject_id: OptionSelected.value,
                  STSubject_error: "",
                  STtopic: [],
                  STTopicOption: [],
                };
              }
            }
            return q;
          });
        });

        TestSubjectTopic(
          OptionSelected.label,
          OptionSelected.category,
          option.subcategory,
          option.course_name
        );
      } else {
        setSubTopic((prevState) => {
          return prevState.map((q) => {
            if (q.id === id) {
              return {
                ...q,
                [name]: "",
                ["STSubject_id"]: "",
                STSubject_error: "",
                STtopic: [],
                STTopicOption: [],
              };
            }
            return q;
          });
        });
        setTestTopic([]);
      }
    } else if (name === "STtopic") {
      const selectTestTopics = option.map((el) => ({
        value: el.value,
        label: el.test_topic,
        type: el.type,
        category: el.category,
        subcategory: el.subcategory,
        course_name: el.course_name,
        subject: el.subject,
        test_topic: el.test_topic,
      }));
      setSubTopic((prevState) => {
        return prevState.map((q) => {
          if (q.id === id) {
            return {
              ...q,
              ["STtopic"]: selectTestTopics,
              STtopic_error: "",
            };
          }
          return q;
        });
      });
    }
  };

  const GetSTopic = async (cate, subcate, coursname, subjectname) => {
    try {
      const res = await AxiosInstance.post("/api/all/getTestTopics/bySubject", {
        category: cate,
        sub_category: subcate,
        course_name: coursname,
        subject: subjectname,
      });
      if (res.data.status && res.data.data.length > 0) {
        return res.data.data.map((item) => ({
          value: item.id,
          label: item.test_topic,
          type: item.type,
          category: item.category,
          subcategory: item.subcategory,
          course_name: item.course_name,
          subject: item.subject,
          test_topic: item.test_topic,
        }));
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching test topics:", error);
      return [];
    }
  };

  const getApplicableBatch = async (fromDate, toDate) => {
    if (fromDate && toDate) {
      try {
        const res = await AxiosInstance.post("api/batch/list", {
          category: "",
          status: [1, 0], // ongoing batches only
          batch_type: "",
          medium: "",
          class_mode: "",
          start_date:
            moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD") + " 00:00:00",
          end_date:
            moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD") + " 23:59:00",
          start_time: "",
          c_start_date: "",
          c_end_date: "",
          end_time: "",
          search: "",
          type: "",
          location: "",
        });
        if (res.data.status && res.data.data.length > 0) {
          return res.data.data.map((item) => ({
            value: item.id,
            label: `${item.name} - ${item.medium}`,
            course_name: item.category_class,
            sub_category: item.subcategory,
            category: item.category,
          }));
        } else {
          return [];
        }
      } catch (error) {
        console.error("Error fetching test topics:", error);
        return [];
      }
    }
  };

  const TestSubjectTopic = (subjectname, cate, subcate, coursname) => {
    AxiosInstance.post("/api/all/getTestTopics/bySubject", {
      category: cate,
      sub_category: subcate,
      course_name: coursname,
      subject: subjectname,
    })
      .then((res) => {
        if (res.data.status === true) {
          if (res.data.data.length > 0) {
            const test_topic = res.data.data.map((item, index) => ({
              value: item.id,
              label: item.test_topic,
              type: item.type,
              category: item.category,
              subcategory: item.subcategory,
              course_name: item.course_name,
              subject: item.subject,
              test_topic: item.test_topic,
            }));
            setTestTopic(test_topic);
          } else {
            setTestTopic([]);
          }
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const validateUpdAnswerSheet = (data, stopic, seleOption) => {
    const errors = {};
    if (data.student_name == "") {
      errors.student_name = "Please enter name.";
    }
    if (data.overall_rank == "") {
      errors.overall_rank = "Please enter rank.";
    }
    if (data.batch_name == "") {
      errors.batch_name = "Please select batch name .";
    }
    if (data.exam_name == "") {
      errors.exam_name = "Please select exam name .";
    }
    if (data.medium_of_instruction === "") {
      errors.medium_of_instruction = "Please select medium of instruction .";
    }
    if (!data.date_of_exam) {
      errors.date_of_exam = "Please select date of exam .";
    }
    if (data.answersheet_path == null) {
      errors.answersheet_path = "Please upload answer sheet .";
    }

    if (stopic.length > 0) {
      const UpdatesubTopic = stopic.map((OB) => {
        let updatedOB = { ...OB };
        if (!OB.STSubject) {
          updatedOB.STSubject_error = "Please Select Subject";
        }
        if (OB.STtopic && OB.STtopic.length === 0) {
          updatedOB.STtopic_error = "Please Select Test Topic";
        }
        return updatedOB;
      });
      setSubTopic(UpdatesubTopic);
    }

    if (!data.batch_range_from) {
      errors.batch_range_from = "Please enter batch from date .";
    }
    if (!data.batch_range_to) {
      errors.batch_range_to = "Please enter batch to date .";
    }
    if (seleOption.length === 0) {
      errors.appliBatch = "Please select applicable batch.";
    }
    validateUpdAnswerSheetFocus(data, stopic, seleOption);
    return errors;
  };

  const validateUpdAnswerSheetFocus = (datas, stopop, opiop) => {
    if (datas.student_name == "") {
      student_name_ref.current.focus();
    } else if (datas.overall_rank == "") {
      overall_rank_ref.current.focus();
    } else if (datas.batch_name == "") {
      batch_name_ref.current.focus();
    } else if (datas.exam_name == "") {
      exam_name_ref.current.focus();
    } else if (datas.medium_of_instruction === "") {
      medium_of_instruction_ref.current.focus();
    } else if (!datas.date_of_exam) {
      datePickerRef.current.setFocus();
    } else if (datas.answersheet_path == null) {
      answersheet_path_ref.current.focus();
    } else if (stopop.length > 0) {
      stopop.map((OB, i) => {
        let updatedOB = { ...OB };
        if (!OB.STSubject) {
          STSubjectref.current[i].current.focus();
        }
        if (OB.STtopic && OB.STtopic.length === 0) {
          STTopicref.current[i].current.focus();
        }
        return updatedOB;
      });
    } else if (!datas.batch_range_from) {
      batch_range_fromRef.current.setFocus();
    } else if (!datas.batch_range_to) {
      batch_range_toRef.current.setFocus();
    } else if (opiop.length === 0) {
      applicable_batch_ref.current.focus();
    }
  };

  const handleSaveAnswerSheet = () => {
    const errors = validateUpdAnswerSheet(fldata, subTopic, selectedOption);
    if (
      Object.keys(errors).length === 0 &&
      subTopic.length > 0 &&
      subTopic.every(
        (el) => el.STSubject !== "" && el.STtopic && el.STtopic.length > 0
      )
    ) {
      const updatSubTopic =
        subTopic.length > 0 &&
        subTopic.map((item) => ({
          subject_id: item.STSubject_id.toString(),
          test_topic_id: item.STtopic.map((topic) => topic.value).join(","),
          id: item?.pks || 0,
        }));

      const saveData = {
        id: id ? parseInt(id) : 0, // for create id as 0 default
        student_name: fldata.student_name,
        over_all_rank: fldata.overall_rank,
        batch_name: fldata.batch_name,
        exam_name: fldata.exam_name,
        medium: fldata.medium_of_instruction,
        exam_date: fldata.date_of_exam,
        answer_sheet_path: fldata.answersheet_path,
        answer_sheet_original_path: fldata.answersheet_original_path,
        applicable_batch:
          selectedOption.length > 0
            ? selectedOption.map((op) => op.value).join(",")
            : "",
        created_dt: moment().format("YYYY:MM:DD HH:mm:ss"),
        created_by: userid_admin,
        subject: updatSubTopic,
        category_name: fldata.category,
        sub_category_name: fldata.sub_category,
        course_name: fldata.course_name,
        batch_id: fldata.batch_id,
        from_date: fldata.batch_range_from,
        to_date: fldata.batch_range_to,
      };
      AxiosInstance.post(`api/test/descriptive/topper_insert`, saveData)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            navigateToPreviousScreen();
          } else {
            toast.error(res.data.message);
            navigateToPreviousScreen();
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setError(errors);
    }
  };

  return (
    <>
      <div className="container-fluid global_container BathHeader">
        <div className="row ">
          {id != null ? (
            <div className=" col-md-6 col-12 ">
              <h6 className="TitleHeader "> Edit Answer Sheet</h6>
            </div>
          ) : (
            <div className=" col-md-6 col-12 ">
              <h6 className="TitleHeader "> Upload Answer Sheet</h6>
            </div>
          )}

          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              {id != null ? (
                <li className="ListBtnItems" onClick={navigateToPreviousScreen}>
                  <Link to="javascript:void(0)" className="secondaryButton">
                    Back to View Answer Sheets
                  </Link>
                </li>
              ) : (
                <li className="ListBtnItems" onClick={navigateToPreviousScreen}>
                  <Link to="javascript:void(0)" className="secondaryButton">
                    Back to Top Performer Answer Sheets
                  </Link>
                </li>
              )}

              <li class="ListBtnItems">
                <Link
                  onClick={handleSaveAnswerSheet}
                  to="javascript:void(0)"
                  className="primaryButton "
                  variant="primary"
                >
                  Save Answer Sheets
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <fieldset className="mt-3">
            <legend className="w-auto">Answer Sheet Details</legend>

            <form className="row g-3">
              {/* -----Student Name------ */}
              <div class="col-md-6">
                <label for="student_name" class="form-label confirm_value ">
                  Student Name
                </label>
                <input
                  ref={student_name_ref}
                  type="text"
                  value={fldata.student_name}
                  placeholder="Student Name"
                  class={`${styles.border_head_color} form-control form-control-sm shadow-none input-font-size`}
                  id="student_name"
                  name="student_name"
                  onChange={handleChange}
                  required
                />
                {error.student_name && (
                  <small className="error_message">{error.student_name}</small>
                )}
              </div>
              {/* --------Overall Rank----------- */}
              <div class="col-md-6">
                <label for="overall_rank" class="form-label confirm_value ">
                  Overall Rank
                </label>
                <input
                  ref={overall_rank_ref}
                  type="number"
                  value={fldata.overall_rank > 0 ? fldata.overall_rank : ""}
                  placeholder="Overall Rank"
                  class={`${styles.border_head_color} form-control form-control-sm shadow-none input-font-size`}
                  id="overall_rank"
                  name="overall_rank"
                  onChange={handleChange}
                  aria-describedby="emailHelp"
                />
                {error.overall_rank && (
                  <small className="error_message">{error.overall_rank}</small>
                )}
              </div>
              {/* --------Batch Name----------- */}

              <div className="col-md-6">
                <label for="batch_name" className="form-label confirm_value">
                  {" "}
                  Batch Name
                </label>
                <Select
                  ref={batch_name_ref}
                  className="shadow-none dropdownarrow_img input-font-size"
                  options={batchList}
                  value={
                    fldata.batch_name !== null && fldata.batch_name !== ""
                      ? {
                          value: fldata.batch_id,
                          label: fldata.batch_name,
                        }
                      : null
                  }
                  placeholder="Batch Name"
                  isClearable
                  name="batch_name"
                  onChange={(option) =>
                    handlesELECToPTIONChange(option, "batch_name")
                  }
                  styles={customStyles}
                />
                {error.batch_name && (
                  <small className="error_message">{error.batch_name}</small>
                )}
              </div>
              {/* -------- Exam Name----------- */}
              <div class="col-md-6">
                <label for="exam_name" class="form-label confirm_value ">
                  Exam Name
                </label>
                <input
                  ref={exam_name_ref}
                  type="text"
                  value={fldata.exam_name}
                  placeholder="Exam Name"
                  class={`${styles.border_head_color} form-control form-control-sm shadow-none input-padding`}
                  id="exam_name"
                  name="exam_name"
                  onChange={handleChange}
                  aria-describedby="exam_name"
                />
                {error.exam_name && (
                  <small className="error_message">{error.exam_name}</small>
                )}
              </div>
              {/* -----Medium of Instruction------- */}
              <div className="col-md-6">
                <label
                  for="medium_of_instruction"
                  className="form-label confirm_value"
                >
                  Medium of Instruction
                </label>
                <Select
                  ref={medium_of_instruction_ref}
                  options={mediumOption}
                  className="shadow-none input-font-size "
                  id="medium_of_instruction"
                  placeholder="Medium of Instruction"
                  isClearable
                  value={
                    fldata.medium_of_instruction !== ""
                      ? {
                          value: fldata.medium_of_instruction,
                          label: fldata.medium_of_instruction_name,
                        }
                      : null
                  }
                  name="medium_of_instruction"
                  onChange={(option) =>
                    handlesELECToPTIONChange(option, "medium_of_instruction")
                  }
                  styles={customStyles}
                />
                {error.medium_of_instruction && (
                  <small className="error_message">
                    {error.medium_of_instruction}
                  </small>
                )}
              </div>
              {/* -----Date of Exam------- */}
              <div className="col-md-6">
                <div className="forms ">
                  <label
                    htmlFor="date_of_exam"
                    class="form-label confirm_value"
                  >
                    Date of Exam
                  </label>
                  <DatePickerSample
                    txtAdMDob={datePickerRef}
                    name={"date_of_exam"}
                    handleChange={(date) =>
                      handleDateChange(date, "date_of_exam")
                    }
                    fieldInput={fldata.date_of_exam}
                  />
                  {error.date_of_exam && (
                    <small className="error_message">
                      {error.date_of_exam}
                    </small>
                  )}
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="forms ">
                  <div className="d-flex">
                    <div className="row">
                      <label
                        for="AnswerSheetFile"
                        class="form-label confirm_value"
                      >
                        Answer Sheet
                      </label>
                    </div>
                    {fldata.answersheet_path !== "" &&
                      fldata.answersheet_path !== null && (
                        <div className={"d-flex align-content-center p-0"}>
                          {fldata.answersheet_path !== "" &&
                            fldata.answersheet_path !== null && (
                              <>
                                <a
                                  target="_blank"
                                  href={`${ImageUrlPrefix}/${fldata.AnswerKeyPath}`}
                                  // style={{ marginTop: "15px" }}
                                >
                                  <Download className="download_icon" />
                                </a>
                              </>
                            )}
                        </div>
                      )}
                  </div>
                  <div className="row">
                    <div
                      className={
                        fldata.answersheet_path !== "" &&
                        fldata.answersheet_path !== null
                          ? "col-md-3 col-5 "
                          : "col-md-12"
                      }
                    >
                      <input
                        ref={answersheet_path_ref}
                        className={
                          fldata.answersheet_path !== "" &&
                          fldata.answersheet_path !== null
                            ? "InputsSelectFile nn_upload_width"
                            : "InputsSelectFile  vv_upload_width"
                        }
                        type="file"
                        id="formFile"
                        name="AnswerSheetFile"
                        onChange={handleChange}
                        required
                      />
                    </div>
                    {fldata.answersheet_path !== "" &&
                      fldata.answersheet_path !== null && (
                        <div
                          className={
                            "col-md-9 col-7 d-flex  align-content-center p-0"
                          }
                        >
                          <span className="nn_upload_fileevaluator">
                            {fldata.answersheet_path !== "" &&
                            fldata.answersheet_path !== null
                              ? fldata.answersheet_original_path
                              : ""}
                          </span>
                          {fldata.answersheet_path !== "" &&
                            fldata.answersheet_path !== null && (
                              <>
                                <span
                                  className={`${styles.verified_uploadeval} material-icons align-middle text-danger`}
                                >
                                  verified
                                </span>
                              </>
                            )}
                        </div>
                      )}
                  </div>

                  {error.answersheet_path && (
                    <span className="error_message">
                      {error.answersheet_path}
                    </span>
                  )}
                </div>
              </div>
            </form>
          </fieldset>
        </div>
        {/* ------------------Subject aand Topics---------------- */}
        <div>
          {subTopic.map((subject, index) => (
            <fieldset key={index} className="mt-3">
              <legend className="w-auto">
                Subjects and Topics {index + 1 > 1 ? `- ${index + 1}` : ""}
              </legend>

              <form className="row g-3">
                {/* -----Subject------- */}
                <div className="col-md-6">
                  <label for="STSubject" className="form-label confirm_value">
                    Subject
                  </label>
                  <Select
                    key={index}
                    ref={STSubjectref.current[index]}
                    className="shadow-none input-font-size"
                    onChange={(es) =>
                      handleSubjectOptionChange(es, subject.id, "STSubject")
                    }
                    name="STSubject"
                    value={
                      subject.STSubject !== null && subject.STSubject !== ""
                        ? {
                            value: subject.STSubject_id,
                            label: subject.STSubject,
                          }
                        : null
                    }
                    options={subject_test}
                    placeholder="Select..."
                    isClearable
                    styles={customStyles}
                  />
                  {subject.STSubject_error && (
                    <small className="error_message">
                      {subject.STSubject_error}
                    </small>
                  )}
                </div>
                {/* -----Test Topic------- */}
                <div className="col-md-6">
                  <label className="form-label confirm_value">Test Topic</label>
                  <Select
                    ref={STTopicref.current[index]}
                    className="shadow-none input-font-size"
                    value={subject.STtopic.map((value) => ({
                      value: value.value,
                      label: value.label,
                      type: value.type,
                      category: value.category,
                      subcategory: value.subcategory,
                      course_name: value.course_name,
                      subject: value.subject,
                      test_topic: value.test_topic,
                    }))}
                    onChange={(e) =>
                      handleSubjectOptionChange(e, subject.id, "STtopic")
                    }
                    options={test_topic}
                    isMulti
                    placeholder="Select..."
                    isClearable
                    styles={customStyles}
                  />
                  {subject.STtopic_error && (
                    <small className="error_message">
                      {subject.STtopic_error}
                    </small>
                  )}
                </div>
              </form>

              <div className="row">
                <div className={`${styles.dflexendcolu} col-md-12`}>
                  {subject.id != 1 && subject.id === subTopic.length && (
                    <a
                      className={`${styles.AddMore_sub} me-3 mt-3 text-decoration-none`}
                      onClick={() => deleteSubTop(subject.id)}
                    >
                      <span className="material-icons download_icon align-middle">
                        remove_circle
                      </span>
                      Delete This Subject
                    </a>
                  )}
                  {subject.id === subTopic.length ? (
                    <a
                      className={`${styles.AddMore_sub} mt-3 text-decoration-none`}
                      onClick={AddSubTop}
                    >
                      <span className="material-icons download_icon align-middle">
                        add_circle
                      </span>
                      Add More Subjects
                    </a>
                  ) : (
                    /* For all other items, show the delete button */
                    <a
                      className={`${styles.AddMore_sub} mt-3 text-decoration-none`}
                      onClick={() => deleteSubTop(subject.id)}
                    >
                      <span className="material-icons download_icon align-middle">
                        remove_circle
                      </span>
                      Delete This Subject
                    </a>
                  )}
                </div>
              </div>
            </fieldset>
          ))}
        </div>

        {/*------- Other Applicate Batch -------*/}
        <div>
          <fieldset className="mt-3">
            <legend className="w-auto">Applicable Batches</legend>

            <form className="row g-3">
              {/* -------Range From ---------- */}
              <div className="col-md-6">
                <div className="forms ">
                  <label
                    htmlFor="batch_range_from"
                    class="form-label confirm_value"
                  >
                    Batch Range From
                  </label>

                  <DatePickerSample
                    txtAdMDob={batch_range_fromRef}
                    name={"batch_range_from"}
                    handleChange={(date) =>
                      handleDateChange(date, "batch_range_from")
                    }
                    fieldInput={fldata.batch_range_from}
                  />
                  {error.batch_range_from && (
                    <small className="error_message">
                      {error.batch_range_from}
                    </small>
                  )}
                </div>
              </div>
              {/* -------Range To ---------- */}
              <div className="col-md-6">
                <div className="forms ">
                  <label htmlFor="range" class="form-label confirm_value">
                    Batch Range To
                  </label>

                  <DatePickerSample
                    txtAdMDob={batch_range_toRef}
                    name={"batch_range_to"}
                    handleChange={(date) =>
                      handleDateChange(date, "batch_range_to")
                    }
                    fieldInput={fldata.batch_range_to}
                  />
                  {error.batch_range_to && (
                    <small className="error_message">
                      {error.batch_range_to}
                    </small>
                  )}
                </div>
              </div>
              {/*---------- Applicable Batches----- */}
              <div className="col-md-6">
                <label className="form-label confirm_value">
                  Applicable Batches
                </label>

                <Select
                  ref={applicable_batch_ref}
                  name="appliBatch"
                  isMulti
                  value={selectedOption}
                  onChange={handleSelectChange}
                  options={appBatch}
                  placeholder="Applicable Batches"
                  className="shadow-none input-font-size"
                  styles={customStyles}
                />
                {error.appliBatch && (
                  <small className="error_message">{error.appliBatch}</small>
                )}
              </div>
            </form>
          </fieldset>
        </div>

        <div className="col-md-12 col-12 ListBtn my-3">
          <ul class="List-Button">
            <li class="ListBtnItems" onClick={navigateToPreviousScreen}>
              <Link to="javascript:void(0)" className="secondaryButton ">
                Back to Top Performer Answer Sheets
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                onClick={handleSaveAnswerSheet}
                to="javascript:void(0)"
                className="primaryButton "
              >
                Save Answer Sheets
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
export default UploadAnswerSheet;
